var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#6C6B6B","fillRule":"evenodd","d":"M20 34c7.732 0 14-6.268 14-14S27.732 6 20 6 6 12.268 6 20s6.268 14 14 14Zm-5-14c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Zm8 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Zm8 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Z","clipRule":"evenodd"}));
}

More.defaultProps = {"fill":"none","viewBox":"0 0 40 40"};

module.exports = More;

More.default = More;
